import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.pad-start.js";
export function TimeToStr(inTime) {
  var time = new Date(inTime * 1000);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y + '.' + add0(m) + '.' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
}
export function add0(m) {
  return m < 10 ? '0' + m : m;
}
export function getDay(day) {
  var today = new Date();
  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds);
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + '-' + tMonth + '-' + tDate;
}
export function doHandleMonth(month) {
  var m = month;
  if (month.toString().length === 1) {
    m = '0' + month;
  }
  return m;
}

/**
 * 获取最近dayNum天的日期时间范围
 * @param {number} dayNum - 最近的天数，默认值为7天
 * @returns {Array} 返回包含开始时间和结束时间的数组，格式为['YYYY-MM-DD 00:00:00', 'YYYY-MM-DD 23:59:59']
 */
export var getLastDaysRange = function getLastDaysRange() {
  var dayNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
  var isTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var now = new Date();
  var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // 获取dayNum天前的日期
  var daysAgo = new Date(today);
  daysAgo.setDate(today.getDate() - dayNum);

  // 格式化日期函数
  var formatDate = function formatDate(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return "".concat(year, "-").concat(month, "-").concat(day);
  };

  // 返回时间范围数组
  if (isTime) {
    return ["".concat(formatDate(daysAgo), " 00:00:00"), "".concat(formatDate(today), " 23:59:59")];
  } else {
    return ["".concat(formatDate(daysAgo)), "".concat(formatDate(today))];
  }
};